(function Index($, Adzuki)
{
	"use strict";
	var $modal = $(".modal");

	Adzuki.onload('MarketingPlans/index', function onload() {
		loadTabsContent();

		$('body').on('ajax-pagination.loaded', function attachShowMarketingPlansDetail() {
			$('#plans .marketing-plans-details').off();
			$('#plans .marketing-plans-details').on('click', showMarketingPlansDetail);
			$('#archived-plans .marketing-plans-details').off();
			$('#archived-plans .marketing-plans-details').on('click', showMarketingPlansDetail);
		});
	});

	function loadTabsContent()
	{
		Adzuki.Ajax.get('/MarketingPlans/plans/')
			.then(function populateVendorCoops(content) {
				$('#plans').html(content);
				Adzuki.Form.initAjaxForm('MarketingPlanSort');
				$('#plans .marketing-plans-details').on('click', showMarketingPlansDetail);
			}
		);

		Adzuki.Ajax.get('/MarketingPlans/archive/')
			.then(function populateCoopProposal(content) {
				$('#archived-plans').html(content);
				$('#archived-plans .marketing-plans-details').on('click', showMarketingPlansDetail);
			}
		);
	}

	function showMarketingPlansDetail(e) {
		var marketing_plan_id = $(this).data("id");

		e.preventDefault();

		$modal.find('.modal-title').text("Marketing Plan Details");
		$modal.find('.modal-body').html('<i class="fa fa-spinner fa-spin fa-2x"></i>&nbsp;Loading...');
		$modal.modal('show');

		Adzuki.Ajax.get('/MarketingPlans/details/' + marketing_plan_id)
		.then(function success(data) {
			$modal.find('.modal-body').html(data);
		});
	}

}(jQuery, window.Adzuki || {}));
